import { doApiCall } from "./utils";
import { AxiosResponse, AxiosError } from "axios";
import { Model, Question } from "survey-core";

const { REACT_APP_MEMBER_PORTAL_ENDPOINT_URL } = process.env;

// For previous answers
interface SurveyPreviousAnswer {
  surveyId: string;
  name: string;
  value: string | boolean | string[];
  questionAsAsked: Question;
}

/**
 * Response type for the getSurveyJson API endpoint.
 * Contains the survey structure and any previous answers for a given survey ID.
 */
export interface GetSurveyJsonResponse {
  /** The unique identifier for this survey */
  surveyId: string;
  /** The survey structure used to build the Survey.js Model */
  structure: Model;
  /** Optional array of previous answers to pre-fill the survey with */
  previousAnswers?: SurveyPreviousAnswer[];
}

export interface SurveyAnswerPayload {
  surveyId: string;
  glMemberId: string;
  name: string;
  value: string | boolean | string[];
  questionAsAsked: Question;
}

/**
 * Payload type for the postSurveyAnswers API endpoint.
 * Contains the survey ID and an array of answers with their associated question data.
 */
export interface PostSurveyAnswersPayload {
  /** The unique identifier for this survey submission */
  surveyId: string;
  /** Array of answers with their associated question data */
  answers: SurveyAnswerPayload[];
}

/**
 * @param surveyId - The ID of the survey to fetch
 * @returns The promise response from the endpoint containing survey structure and previous answers
 */
export const getSurveyJson = (
  surveyId: string
): Promise<AxiosResponse | AxiosError> => {
  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "GET",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/member/survey/${surveyId}`
  };

  return doApiCall(request);
};

/**
 * @param payload - The survey answers payload to post
 * @returns The promise response from the endpoint
 */
export const postSurveyAnswers = (
  payload: PostSurveyAnswersPayload
): Promise<AxiosResponse | AxiosError> => {
  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "POST",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/member/survey`,
    data: payload,
    body: JSON.stringify(payload)
  };

  return doApiCall(request);
};
